/* Spellpaws: client-side "Spell tier" sort on the loaded page + keep sort when switching collections */
(()=>{
  const OPTS=[['sp-tier-asc','Spell tier: Cantrip → Forbidden'],['sp-tier-desc','Spell tier: Forbidden → Cantrip']];
  const url=()=>new URL(location.href);
  const current=()=>url().searchParams.get('sp_sort');
  function sortGrid(dir){
    document.querySelectorAll('ul.product-grid, .product-grid').forEach(g=>{
      const items=[...g.querySelectorAll(':scope > li[data-tier-rank]')]; if(!items.length) return;
      items.forEach((li,i)=>{ if(li.dataset.spIdx==null) li.dataset.spIdx=i; });
      items.sort((a,b)=>{
        if(!dir) return a.dataset.spIdx-b.dataset.spIdx;
        const ra=+a.dataset.tierRank||9, rb=+b.dataset.tierRank||9;
        return (dir==='asc'?ra-rb:(rb%9)-(ra%9)) || a.dataset.spIdx-b.dataset.spIdx;
      });
      const cur=[...g.querySelectorAll(':scope > li[data-tier-rank]')];
      if(items.every((li,i)=>li===cur[i])) return;
      items.forEach(li=>g.appendChild(li));
    });
  }
  function apply(){const s=current(); document.documentElement.classList.toggle('sp-tier-sorted',!!(s&&s.startsWith('sp-tier'))); sortGrid(s==='sp-tier-asc'?'asc':s==='sp-tier-desc'?'desc':null); label();}
  function label(){
    const s=current(), name=(OPTS.find(o=>o[0]===s)||[])[1];
    document.querySelectorAll('select[name="sort_by"]').forEach(sel=>{ if(name) sel.value=s; });
    document.querySelectorAll('.sorting-filter__input[name="sort_by"]').forEach(inp=>{ if(name) inp.checked=inp.value===s; });
  }
  function inject(){
    document.querySelectorAll('select[name="sort_by"]').forEach(sel=>{
      if(sel.querySelector('[value="sp-tier-asc"]')) return;
      OPTS.forEach(([v,n])=>{const o=document.createElement('option');o.value=v;o.textContent=n;sel.appendChild(o);});
    });
    document.querySelectorAll('.sorting-filter__options-inner').forEach(box=>{
      if(box.querySelector('[value="sp-tier-asc"]')) return;
      const tpl=box.querySelector('.sorting-filter__option'); if(!tpl) return;
      OPTS.forEach(([v,n])=>{
        const l=tpl.cloneNode(true), inp=l.querySelector('input');
        const id=inp.id.replace(/sort-option-[^-]+(-?)/,'sort-option-'+v+'$1');
        inp.id=id; l.setAttribute('for',id); inp.value=v; inp.checked=false; inp.dataset.optionName=n;
        l.setAttribute('aria-selected','false'); l.querySelector('.sorting-filter__label').textContent=n;
        box.appendChild(l);
      });
    });
    label();
  }
  // intercept before the theme's facets form submits sort_by=sp-...
  ['change','click'].forEach(ev=>document.addEventListener(ev,e=>{
    const t=e.target.closest && e.target.closest('[name="sort_by"], .sorting-filter__option');
    if(!t) return;
    const inp=t.matches('input,select')?t:t.querySelector('input'); if(!inp) return;
    const v=inp.value, u=url();
    if(v.startsWith('sp-tier')){
      if(ev==='click' && inp.tagName!=='SELECT'){ inp.checked=true; }
      if(ev==='change'||inp.tagName!=='SELECT'){
        e.stopImmediatePropagation(); if(ev==='click') e.preventDefault();
        u.searchParams.set('sp_sort',v); history.replaceState(null,'',u); apply();
        const d=inp.closest('details'); if(d) d.removeAttribute('open');
      }
    } else if(ev==='change' && u.searchParams.has('sp_sort')){
      u.searchParams.delete('sp_sort'); history.replaceState(null,'',u);
    }
  },true));
  // preserve sort param on collection links
  document.addEventListener('click',e=>{
    const a=e.target.closest && e.target.closest('a[data-sp-keep-sort]'); if(!a) return;
    const here=url(), dest=new URL(a.href);
    ['sort_by','sp_sort'].forEach(k=>{const v=here.searchParams.get(k); if(v) dest.searchParams.set(k,v);});
    a.href=dest.toString();
  },true);
  const run=()=>{inject();apply();};
  document.addEventListener('DOMContentLoaded',run);
  if(document.readyState!=='loading') run();
  // re-apply after filter/infinite-scroll re-renders
  let tm; new MutationObserver(()=>{clearTimeout(tm);tm=setTimeout(run,120);}).observe(document.documentElement,{childList:true,subtree:true});
})();
